import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var themeOptions = function () { return ({
    components: {
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    backgroundColor: "".concat(designTokens.color.gray.light.value),
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=tutorialTheme.js.map